export default "__VITE_PUBLIC_ASSET__c5d225bf__"